import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { firstName } from "../../lib/names";

export const CustomGroupDialog = ({ open, onOpenChange, students, onSave, editingGroup }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);

  useEffect(() => {
    if (editingGroup) {
      setName(editingGroup.name);
      setDescription(editingGroup.description || "");
      setSelectedStudents(editingGroup.student_ids || []);
    } else {
      setName(""); setDescription(""); setSelectedStudents([]);
    }
  }, [editingGroup, open]);

  const handleToggleStudent = (studentId) => {
    setSelectedStudents(prev => prev.includes(studentId) ? prev.filter(id => id !== studentId) : [...prev, studentId]);
  };

  const handleSave = () => {
    if (!name.trim()) { toast.error("Please enter a group name"); return; }
    if (selectedStudents.length === 0) { toast.error("Please select at least one student"); return; }
    onSave({ name, description, student_ids: selectedStudents });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader><DialogTitle>{editingGroup ? "Edit Custom Group" : "Create Custom Group"}</DialogTitle></DialogHeader>
        <div className="space-y-4 flex-1 overflow-auto">
          <div className="space-y-2">
            <Label>Group Name *</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g., Skiing Group, Reading Intervention" />
          </div>
          <div className="space-y-2">
            <Label>Description (optional)</Label>
            <Input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Brief description" />
          </div>
          <div className="space-y-2">
            <Label>Select Students ({selectedStudents.length} selected)</Label>
            <div className="border rounded-lg max-h-60 overflow-y-auto p-2">
              {students.sort((a, b) => (a.preferred_name || a.first_name).localeCompare(b.preferred_name || b.first_name)).map((student) => (
                <label key={student.id}
                  className={`flex items-center gap-2 p-2 rounded cursor-pointer hover:bg-gray-50 ${selectedStudents.includes(student.id) ? 'bg-blue-50' : ''}`}>
                  <input type="checkbox" checked={selectedStudents.includes(student.id)}
                    onChange={() => handleToggleStudent(student.id)} className="w-4 h-4 text-[#00305E] rounded" />
                  <span className="text-sm">{firstName(student)}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleSave} className="bg-[#00305E] hover:bg-[#00305E]/90">
            {editingGroup ? "Save Changes" : "Create Group"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
